import React, { useState, useEffect } from 'react'
import ReactLoading from "react-loading";
import { useHistory } from 'react-router-dom';

import api from '../../services/api'
import { URL } from '../../constants/index'
import LogoBranco from '../../assets/LogoBranco.png';
import '../Login/styles.css'

const CadastrarSenha = (props) => {
  const [token, setToken] = useState("");
  const [erroCadastrar, setErroCadastrar] = useState("");
  const [senha, setSenha] = useState("");
  const [repetirSenha, setRepetirSenha] = useState("");
  const [tokenInvalido, setTokenInvalido] = useState(true);
  const [loading, setLoading] = useState(true);

  const history = useHistory();

  const definirToken = () => {
    const param = new URLSearchParams(props.location.search);
    const tk = param.get("token");
    setToken(tk);
    return tk;
  }

  useEffect(() => {
    const tk = definirToken();

    api.get("api/login/confirmartokensenha", {
      params: { token: tk }
    })
    .then(res => {
      setTokenInvalido(false);
      setLoading(false);
    })
    .catch(err => {
      setTokenInvalido(true);
      setLoading(false);
    })
  }, [props.location.search]);

  const tratarErroCadastrarSenha = erro => {
    setErroCadastrar(erro);
  }

  const handleCadastrarSenha = e => {
    e.preventDefault()
    if (!validarFormulario()) {
      return false;
    }
    setLoading(true);

    api.post("/api/login/alterarsenha",
      {
        token,
        senha: btoa(senha)
      },
      {
        headers: { "Content-Type": "application/json" }
      }
    )
    .then(res => {
      onRetornarLogin();
    })
    .catch(err => {
      setLoading(false);
      if (err.response && err.response.data) {
        tratarErroCadastrarSenha(err.response.data.message);
      } else {
        tratarErroCadastrarSenha("Erro ao se comunicar com API");
      }
    });
  }

  const validarFormulario = () => {
    if (!senha || !repetirSenha) {
      tratarErroCadastrarSenha("Ambas as senhas precisam ser informadas")
      return false;
    }
    if (senha !== repetirSenha) {
      tratarErroCadastrarSenha("As senhas não coincidem")
      return false;
    }
    return true;
  }

  const onRetornarLogin = e => {
    history.push(URL.URLLogin);
  }

  return (
    <div className="login-container">
      <div className="login-visual">
        <div className="visual-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
        <div className="visual-content">
          <img src={LogoBranco} alt="PWI Sistemas" className="login-logo-large" />
          <h1 className="visual-title">VolpeBI</h1>
        </div>
      </div>

      <div className="login-form-section">
        <div className="login-form-wrapper">
          <div className="login-header">
            <h2>Cadastrar Senha</h2>
            <p>Por favor, informe sua nova senha de acesso.</p>
          </div>

          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', margin: '40px 0' }}>
              <ReactLoading type="bubbles" color="#0082C8" height={64} width={64} />
            </div>
          ) : tokenInvalido ? (
            <div className="login-form">
              <div className="login-error-alert" style={{ marginBottom: '24px' }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                <span>Token inválido ou expirado.</span>
              </div>
              <button type="button" className="btn-secondary" onClick={onRetornarLogin}>
                Voltar para Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleCadastrarSenha} className="login-form">
              {erroCadastrar && (
                <div className="login-error-alert">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>{erroCadastrar}</span>
                </div>
              )}

              <div className="login-input-group">
                <label htmlFor="senha">Nova Senha</label>
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                  <input
                    type="password"
                    id="senha"
                    placeholder="Digite sua nova senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="login-input-group">
                <label htmlFor="repetir-senha">Repetir Senha</label>
                <div className="input-wrapper">
                  <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                  <input
                    type="password"
                    id="repetir-senha"
                    placeholder="Confirme sua nova senha"
                    value={repetirSenha}
                    onChange={(e) => setRepetirSenha(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn-primary">
                Definir Senha
              </button>

              <button type="button" className="btn-secondary" onClick={onRetornarLogin} style={{ marginTop: '16px' }}>
                Voltar para Login
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}

export default CadastrarSenha;
